import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useLayoutEffect, useRef, useState } from 'react';
var transition = 'height 200ms ease-out';

function Collapse(props) {
  var children = props.children,
      instant = props.instant,
      lazy = props.lazy,
      onComplete = props.onComplete,
      open = props.open,
      restProps = _objectWithoutPropertiesLoose(props, ["children", "instant", "lazy", "onComplete", "open"]);

  var _useState = useState(lazy ? open : true),
      renderChildren = _useState[0],
      setRenderChildren = _useState[1];

  var ref = useRef();
  var firstRender = useRef(true);
  var instantRender = instant || firstRender.current;

  function openCollapse() {
    var node = ref.current;
    requestAnimationFrame(function () {
      node.style.height = node.scrollHeight + 'px';
    });
  }

  function closeCollapse() {
    var node = ref.current;
    requestAnimationFrame(function () {
      node.style.height = node.offsetHeight + 'px';
      node.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        node.style.height = 0;
      });
    });
  }

  useLayoutEffect(function () {
    if (lazy) {
      if (open) {
        if (renderChildren) {
          openCollapse();
        } else {
          setRenderChildren(true);
        }
      } else {
        closeCollapse();
      }
    } else {
      if (open) {
        openCollapse();
      } else {
        closeCollapse();
      }
    }
  }, [open, renderChildren]);
  useLayoutEffect(function () {
    var node = ref.current;

    function handleComplete() {
      node.style.overflow = open ? 'initial' : 'hidden';

      if (open) {
        requestAnimationFrame(function () {
          node.style.margin = null;
          node.style.height = 'auto';
        });
      }

      if (!open && lazy) {
        node.style.margin = '0';
        setRenderChildren(false);
      }

      if (firstRender.current) {
        firstRender.current = false;
      } else if (onComplete) {
        onComplete();
      }
    }

    function handleTransitionEnd(event) {
      if (event.target === node && event.propertyName === 'height') {
        handleComplete();
      }
    }

    if (instantRender) {
      handleComplete();
    }

    node.addEventListener('transitionend', handleTransitionEnd);
    return function () {
      node.removeEventListener('transitionend', handleTransitionEnd);
    };
  }, [open]);
  return jsx("div", _extends({
    ref: ref,
    css: {
      transition: instantRender ? undefined : transition
    }
  }, restProps), renderChildren ? children : null);
}

export default Collapse;